import React from "react";
import { ManualClientPositionForm } from "./ManualClientPositionForm";

interface CreateManualClientPositionFormProps {
    onSuccess: () => void;
    onCancel?: () => void;
    showCancelButton?: boolean;
    defaultSourceType?: string;
}

export function CreateManualClientPositionForm({ onSuccess, onCancel, showCancelButton = true, defaultSourceType }: CreateManualClientPositionFormProps) {
    return (
        <ManualClientPositionForm
            mode="create"
            onSuccess={onSuccess}
            onCancel={onCancel}
            showCancelButton={showCancelButton}
            defaultSourceType={defaultSourceType}
        />
    );
}
